module.exports = __webpack_public_path__ + "static/img/bcg3.ac09931e.webp";